export default __webpack_public_path__ + "8e75202187179dfe565f484980e62d7d.png";